module.exports = __webpack_public_path__ + "static/media/manu-12.b7e77aa9.png";